import SolutionPage from './index';

export default function DigitalTwinPage() {
  return <SolutionPage pageId="digital-twin" />;
}
